import { useEffect, useRef } from "react";
import { useAuth } from "../hooks/useAuth";
import { useAppModals } from "../hooks/useAppModals";
import { createCheckoutSession } from "../api/services";

/**
 * When user signs in with pendingCheckoutPriceId, creates Stripe checkout session and redirects.
 */
export const CheckoutHandler = () => {
  const { isAuthenticated } = useAuth();
  const { pendingCheckoutPriceId, clearPendingCheckout } = useAppModals();
  const processingRef = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || !pendingCheckoutPriceId || processingRef.current) return;

    const priceId = pendingCheckoutPriceId;
    processingRef.current = true;
    clearPendingCheckout();

    createCheckoutSession(priceId)
      .then(({ url }) => {
        window.location.href = url;
      })
      .catch((err) => {
        console.error("[CheckoutHandler] Failed to create session:", err);
        processingRef.current = false;
      });
  }, [isAuthenticated, pendingCheckoutPriceId, clearPendingCheckout]);

  return null;
};
